import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

export const minutesOperations = (time: string, num: number): string => {
  dayjs.extend(duration);
  const [hours, minutes] = time.split(':');

  return dayjs.duration({ hours: +hours, minutes: +minutes }).add(num, 'm').format('HH:mm:ss');
};
